import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#trainee_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Job Placement List By Bill")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_info",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_19 = { class: "col-md-3 mt-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Random Selection %", -1)
const _hoisted_21 = { class: "col-md-2 mt-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "card mb-5 mb-xl-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_29 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-3" }
const _hoisted_32 = { class: "row w-100 m-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_34 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  placeholder: "--Select Tranche--",
                  modelValue: _ctx.trainee.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trancheChange()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "--Select Tranche--"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select Tranche--")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_el_select, {
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  class: "form-select-solid",
                  placeholder: "--Select Training Partner--",
                  modelValue: _ctx.trainee.entity_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                  style: {"width":"100%"},
                  filterable: "",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainingInstitute()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "--Select Training Partner--"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select Training Partner--")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: assoc.id,
                        label: assoc.entity_short_name,
                        value: assoc.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Institute",
                  modelValue: _ctx.trainee.training_institute_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "--Select Institute--"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select Institute--")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: inst.id,
                        label: inst.institute_name,
                        value: inst.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(inst.institute_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "--Select Bill--",
                  modelValue: _ctx.trainee.bill_no,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainee.bill_no) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: bl.bill_sequence_no,
                        label: bl.bill_no,
                        value: bl.bill_sequence_no
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bl.bill_no), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_Field, {
                  modelValue: _ctx.trainee.random_per,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainee.random_per) = $event)),
                  name: "permanent_address",
                  class: "form-control form-control-sm",
                  style: {"height":"40px","width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getTraineeList())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_22
                ])
              ])
            ]),
            (_ctx.showtraineeInfo == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
              : _createCommentVNode("", true),
            (_ctx.showtraineeInfo == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("h4", _hoisted_26, "Employed Trainees (Total Trainee: " + _toDisplayString(_ctx.total_trainee) + " | Total Record: " + _toDisplayString(_ctx.traineeList.length) + ") ", 1),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_36),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_38),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_40)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.traineeList,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-entity": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.entity_info?.entity_short_name), 1)
                              ]),
                              "cell-institute": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.institute_info?.institute_name), 1)
                              ]),
                              "cell-course_info": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.course_info?.course_name), 1)
                              ]),
                              "cell-tranche": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.tranche_info?.label), 1)
                              ]),
                              "cell-batch_info": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.batch_info?.batch_number), 1)
                              ]),
                              "cell-reg_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.registration_number), 1)
                              ]),
                              "cell-name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.trainee_name), 1)
                              ]),
                              "cell-gender": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.gender), 1)
                              ]),
                              "cell-birth_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.date_of_birth
                                                            ? _ctx.moment(industry?.date_of_birth).format(
                                                                'DD-MM-YYYY'
                                                            )
                                                            : industry?.date_of_birth), 1)
                              ]),
                              "cell-phone": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.mobile), 1)
                              ]),
                              "cell-alt_mob": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.alternative_mobile), 1)
                              ]),
                              "cell-org_name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.organization_name), 1)
                              ]),
                              "cell-org_add": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.organization_address), 1)
                              ]),
                              "cell-j_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.joining_date), 1)
                              ]),
                              "cell-designation": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.designation), 1)
                              ]),
                              "cell-salary": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.salary), 1)
                              ]),
                              "cell-start_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.batch_info?.start_date
                                                            ? _ctx.moment(industry?.batch_info?.start_date).format(
                                                                'DD-MM-YYYY'
                                                            )
                                                            :industry?.batch_info?.start_date), 1)
                              ]),
                              "cell-end_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.batch_info?.end_date
                                                            ? _ctx.moment(industry?.batch_info?.end_date).format(
                                                                'DD-MM-YYYY'
                                                            )
                                                            : industry?.batch_info?.end_date), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}